import { Stack, Text } from "@chakra-ui/react";

import Button from "components/Chakra/Button";
import IconPause from "components/Chakra/Icons/Pause";
import IconPlay from "components/Chakra/Icons/Play";
import { EOfferStatus } from "utils/offer";
import { useTracking } from "contexts/Tracking";
import IconTrash from "components/Chakra/Icons/Trash";
import { TActivation } from ".";
import { useAlertModal } from "modals/useAlertModal";
import useHelperCRM from "hooks/useHelperCRM";
import { usePutOfferStatusChangeMutation } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";

type TopActionButtonType = {
  id: number;
  status: EOfferStatus;
  getOffers: () => void;
  activationHandler: (id: number, action: TActivation) => void;
};

const TopActionButton: React.FC<TopActionButtonType> = ({
  status,
  id,
  getOffers,
  activationHandler,
}) => {
  const { trackEvent } = useTracking();
  const { openModal: openAlertModal } = useAlertModal();
  const { updateUserOffer } = useHelperCRM();

  const [changeOfferStatusApi] = usePutOfferStatusChangeMutation();

  const deleteOnSubmit = (): void => {
    updateUserOffer({
      offerId: id.toString(),
      data: {
        id: id.toString(),
        date: new Date().toISOString(),
        offerId: id.toString(),
        status: "offer_deleted",
      },
    });
    changeOfferStatusApi({
      statusChangeRequest: { offerId: id, status: "delete" },
    }).then(() => {
      getOffers();
    });
  };

  return (
    <Stack>
      {(status === EOfferStatus.ACTIVE ||
        status === EOfferStatus.DRAFT ||
        status === EOfferStatus.CANCELED) && (
        <Button
          dataTest="global.stopOrPublishButton"
          variant="link"
          onClick={() => {
            if (status === EOfferStatus.DRAFT) {
              trackEvent({
                "dl.eCat": "inzerce",
                "dl.eAct": "zverejnit_znovu",
                "dl.eLab": "moje_inzeraty",
              });
            }
            activationHandler(
              id,
              status === EOfferStatus.ACTIVE ? "deactivate" : "activate",
            );
          }}
          leftIcon={
            status === EOfferStatus.ACTIVE ? (
              <IconPause fillWith="ud-primary" boxSize="20px" />
            ) : (
              <IconPlay fillWith="ud-primary" boxSize="20px" />
            )
          }
        >
          <Text as="span" variant="small_2" color="ud-primary">
            {status === EOfferStatus.ACTIVE ? "Pozastavit" : "Zveřejnit"}
          </Text>
        </Button>
      )}
      {status !== EOfferStatus.ACTIVE && (
        <Button
          variant="link"
          data-test="offerDetail.inactive.trash"
          trackEventPayload={{
            "dl.eCat": "inzerce",
            "dl.eAct": "click_smazat",
            "dl.eLab": "moje_inzeraty",
          }}
          leftIcon={
            <IconTrash id="Trash" fillWith="ud-primary" boxSize="17px" />
          }
          onClick={() =>
            openAlertModal({
              title: "Opravdu chcete inzerát smazat?",
              onSubmit: () => deleteOnSubmit(),
              cancelText: "NE, ponechat",
              submitText: "ANO, smazat",
            })
          }
        >
          <Text variant="small_2" color="ud-primary">
            Smazat
          </Text>
        </Button>
      )}
    </Stack>
  );
};
export default TopActionButton;
